import { openBlock, createElementBlock, createElementVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {};
const _hoisted_1 = {
  width: "16",
  height: "19",
  viewBox: "0 0 16 19",
  stroke: "none",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.4",
  d: "M1.14258 3.5625V17.2188C1.14258 18.2021 1.91044 19 2.85686 19H13.1426C14.089 19 14.8569 18.2021 14.8569 17.2188V3.5625H1.14258ZM5.14258 15.4375C5.14258 15.7668 4.88811 16.0312 4.57115 16.0312C4.25419 16.0312 3.99972 15.7668 3.99972 15.4375V7.125C3.99972 6.79565 4.25419 6.53125 4.57115 6.53125C4.88811 6.53125 5.14258 6.79565 5.14258 7.125V15.4375ZM8.57115 15.4375C8.57115 15.7668 8.31668 16.0312 7.99972 16.0312C7.68276 16.0312 7.42829 15.7668 7.42829 15.4375V7.125C7.42829 6.79565 7.68276 6.53125 7.99972 6.53125C8.31668 6.53125 8.57115 6.79565 8.57115 7.125V15.4375ZM11.9997 15.4375C11.9997 15.7668 11.7453 16.0312 11.4283 16.0312C11.1113 16.0312 10.8569 15.7668 10.8569 15.4375V7.125C10.8569 6.79565 11.1113 6.53125 11.4283 6.53125C11.7453 6.53125 11.9997 6.79565 11.9997 7.125V15.4375Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M15.4286 1.1875H11.4286L11.0151 0.328158C10.9183 0.127025 10.7204 0 10.504 0H5.49604C5.27957 0 5.08175 0.127025 4.98493 0.328158L4.57143 1.1875H0.571429C0.255857 1.1875 0 1.45328 0 1.78125V2.96875C0 3.29665 0.255857 3.5625 0.571429 3.5625H15.4286C15.7442 3.5625 16 3.29665 16 2.96875V1.78125C16 1.45328 15.7442 1.1875 15.4286 1.1875Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
const TrashIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  TrashIcon as default
};
//# sourceMappingURL=TrashIcon.vue.es.js.map
